import { render, staticRenderFns } from "./FolderChildren.vue?vue&type=template&id=11d65617"
import script from "./FolderChildren.vue?vue&type=script&lang=js"
export * from "./FolderChildren.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports